import { render } from "./AccountsList.vue?vue&type=template&id=37d80644&scoped=true"
import script from "./AccountsList.vue?vue&type=script&lang=js"
export * from "./AccountsList.vue?vue&type=script&lang=js"

import "./AccountsList.vue?vue&type=style&index=0&id=37d80644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d80644"],['__file',"src/views/AccountsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37d80644"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37d80644', __exports__)) {
    api.reload('37d80644', __exports__)
  }
  
  module.hot.accept("./AccountsList.vue?vue&type=template&id=37d80644&scoped=true", () => {
    api.rerender('37d80644', render)
  })

}


export default __exports__